import { Button as AntButton, ButtonProps } from "antd";
interface IButton extends ButtonProps {
  children?: any;
}
const Button = ({ children, ...rest }: IButton) => (
  <AntButton {...rest}>{children}</AntButton>
);

export default Button;
